import appboy from '@braze/web-sdk'

export const initializeBrazeClient = (
  writeKey: string,
  baseUrl: string,
  enableLogging = true,
) => {
  try {
    appboy.initialize(writeKey, {
      baseUrl,
      enableLogging,
    })
  } catch (e) {
    console.warn('Braze could not initialize.')
  }
}

export const initializeBrazeSession = (userId: string) => {
  appboy.changeUser(userId)

  appboy.display.automaticallyShowNewInAppMessages()

  appboy.openSession()
}
